import styled from 'styled-components';
import Modal, { BaseModalBackground } from 'styled-react-modal';
import breakpoints from '../breakpoints';

export const StyledModal = Modal.styled`
  width: 100%;
  height: 100%;
  background-color: #f1f1f1;
  border: 1px solid #ccc;
  overflow: scroll;
  text-align: left;
`
  
export const ModalBody = styled.section`
  display: flex;
  flex-direction: column;
  width: 80%;
  padding-top: 20px;
  margin-left: auto; 
  margin-right: auto;
  ${breakpoints('mobile', 'down')}{
    width: 100%;
    padding: 0;
    margin: 0;
  }
`

export const Heading = styled.section`
  padding: 30px 0;
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  ${breakpoints('mobile', 'down')}{
    display: flex;
    width: calc(100% - 40px);
    padding: 0 20px 30px 20px;
    flex-direction: column;
  }
 
`

export const HeadingDescription = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 48%;
  h1 {
    line-height: 45px;
  }
  ${breakpoints('mobile', 'down')}{
    flex-direction: column;
    align-self: center;
  }
`

export const HeadingImage = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 48%;
`

export const ImageContainer = styled.div`
  img {
    width: 100%;
  }
  ${breakpoints('mobile', 'down')}{
    margin: 0 0 20px 0;
  }
`

export const PatentsContainer = styled.div``

export const PatentsSection = styled.section`
  border-top: 2px solid black;
  border-bottom: 2px solid black;
  padding: 30px 0 30px 0;
  display: flex;
  width: 100%;
  flex-direction: column;
  flex-wrap: wrap;

  ${breakpoints('mobile', 'down')}{
    display: flex;
    flex-direction: column;
    align-items: left;
    width: calc(100% - 40px);
    padding: 30px 20px;
    border-top: 1px solid black;
    border-bottom: 1px solid black;
  }
`

export const PatentNumbers = styled.div`
  display:flex;
  flex-direction: row;
  flex 1;
  justify-content: space-between;
  ${breakpoints('mobile', 'down')} {
    flex-direction: column;
  }
`
export const USPatents = styled.div`
  font-family: 'ToyotaType Book';
  flex: 1 0 48%;
`

export const USPatentApplications = styled.div`
  font-family: 'ToyotaType Book';
  flex: 0 0 48%;
`

export const SelectorSection = styled.div`
display: flex;
flex-direction: row;
width: 100%;
justify-content: space-between;
`

export const Faqs = styled.section`
  padding: 30px 0 30px 0;
  width: 100%;
  ${breakpoints('mobile', 'down')}{
    padding: 30px 0 0 0;
  }
`
export const ListSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`

export const Footer = styled.section`
  font-family: 'ToyotaType Book';
  border-top: 2px solid black;
  padding-top: 20px;
  width: 100%;
  ${breakpoints('mobile', 'down')}{
    border-top: 1px solid #bfbfbf;
    width: calc(100% - 40px);
    padding: 20px 20px 0 20px;
    margin: 30px 0 0 0;
  }
`

export const Title = styled.h1`
  font-family: 'ToyotaType Semibold';
  font-weight: bold;
`
export const Subtitle = styled.span`
  font-family: 'ToyotaType Semibold';
  font-weight: bold;
  font-size: 13px;
	line-height: 20px;
	letter-spacing: 0.05em;
`

export const LicensingContent = styled.div`
  padding-top: 20px;
`

export const PatentsDescription = styled.div`
  width: 100%;
  margin-bottom: 15px;
  span {
    p {
      a {
        color: #CC0000;
        font-weight: 900;
        &:hover {
          color: #990000;
        }
      }
    }
  }
`

export const DescriptionSummary = styled.div`
  display: flex;
  flex-direction: column;
  & > span {
    padding-top: 10px;
  }
`

export const LicensingCategories = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  img {
    width: 100%;
  }
`

export const LicensingHeading = styled.span`
  font-family: 'ToyotaType Semibold';
  font-weight: bold;
  font-size: 13px;
	line-height: 20px;
	letter-spacing: 0.05em;
`

export const PortfolioDescription = styled.p`
  font-family: "ToyotaType Book";
	font-size: 13px;
	line-height: 20px;
	letter-spacing: 0.05em;
`


export const LongDescription = styled.div`
  width: 100%;
`

export const PatentHeading = styled.div`
  flex 1;
  display: flex;
  flex-direction: column;
`
export const PatentsTitle = styled.div`
  padding-bottom: 10px;
`

export const PortfolioTitle = styled.span`
  font-family: "ToyotaType Semibold";
  font-weight: bold;
	font-size: 18px;
	line-height: 20px;
	letter-spacing: 0.05em;
  padding: 15px 0;
`


export const PreviousPortfolio = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 48%;
`

export const NextPortfolio = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 48%;
`

export const FooterHeading = styled.div`

`

export const LicensingList = styled.ul`
  font-family: "ToyotaType Book";
  width: 90%;
	font-size: 13px;
	line-height: 20px;
	letter-spacing: 0.05em;
  list-style: none;
  margin: 0;
  padding-top: 15px;
  padding-left: 0;
`

export const License = styled.li`
`
export const PatentsList = styled.ul`
  list-style: none;
  padding:0 ;
  margin-top: 5px;
  column-count: ${({patents}) => (patents > 8) ? 2 : 1};
  column-fill: balance;
  -moz-column-fill: balance;
  -webkit-column-fill: balance;
`

export const Patent = styled.li`
  font-family: 'ToyotaType Book';
  font-size: 13px;
	line-height: 20px;
	letter-spacing: 0.05em;
`
export const PatentsReference = styled.div`
  font-family: 'ToyotaType Book';
  font-size: 10px;
	line-height: 14px;
	letter-spacing: 0.05em;
  display: flex;
  flex: 1;
  flex-direction: column;
`

export const FaqsList = styled.ul`
  flex: 0 0 48%;
  list-style: none;
  padding: 0;
  margin: 0;
  ${breakpoints('mobile', 'down')}{
    width: calc(100% - 40px);
    padding: 0 20px;
  }
`

export const Faq = styled.li`
  display: flex;
  flex-direction: column;
  width: 85%;
`

export const Question = styled.div`
  padding: 15px 0 15px 0;
`

export const Answer = styled.div``


export const CTAWrapper = styled.div`
  font-family: 'ToyotaType Semibold';
  font-weight: bold;
  display: flex;
  justify-content: center;
  padding: 40px;
  margin: 10px;
`

export const NextPortolioButton = styled.button`
  display: flex;
  font-family: "ToyotaType Semibold";
  font-weight: bold;
	font-size: 13px;
	line-height: 20px;
	letter-spacing: 0.05em;
  padding: 15px 0;
  border: none;
  background-color: inherit;
  justify-content: ${({right}) => right ? 'flex-end' : 'flex-start'};  
  margin-top: auto;
  &:hover {
    cursor: pointer;
    span {
      color: black;
    }
  }
`

export const Arrow = styled.span`
  color: #CC0000;
  font-size: 20px;
`

export const CloseButton = styled.img`
  padding: 10px 10px 0 0;
  align-self: flex-end;
  cursor: pointer;
`

export const FadeBackground = styled(BaseModalBackground)`
  opacity: ${props => props.opacity};
  transition: opacity ease 200ms;
`